module.exports = __webpack_public_path__ + "static/img/s1.a9a914a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-CN/s1.png
// module id = LY7q
// module chunks = 1